import { __assign, __extends, __rest } from "tslib";
import React, { Component } from "react";
import { View } from "react-native";
import PropTypes from "prop-types";
import styles from "./PnmacTable.styles.js";
import PnmacCell from "./PnmacCell";
import { sum } from "./sum";
import { textStyle as textStyleThem } from "../v2/theme";
var PnmacRow = /** @class */function (_super) {
  __extends(PnmacRow, _super);
  function PnmacRow() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  PnmacRow.prototype.render = function () {
    var _a = this.props,
      data = _a.data,
      noBorder = _a.noBorder,
      style = _a.style,
      widthArr = _a.widthArr,
      height = _a.height,
      flexArr = _a.flexArr,
      textStyle = _a.textStyle,
      props = __rest(_a, ["data", "noBorder", "style", "widthArr", "height", "flexArr", "textStyle"]);
    var width = widthArr ? sum(widthArr) : 0;
    return data ? (/*#__PURE__*/React.createElement(View, {
      style: [height && {
        height: height
      }, width && {
        width: width
      }, styles.row, style]
    }, data.map(function (item, i) {
      var flex = flexArr && flexArr[i];
      var wth = widthArr && widthArr[i];
      return /*#__PURE__*/React.createElement(PnmacCell, __assign({
        key: "PnmacRow_".concat(data.length, "_").concat(i),
        style: __assign({
          height: "auto"
        }, noBorder ? {} : textStyleThem.formLineWeight),
        data: item,
        width: wth,
        height: height,
        flex: flex,
        textStyle: textStyle
      }, props));
    }))) : null;
  };
  return PnmacRow;
}(Component);
PnmacRow.propTypes = {
  style: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.array])
};
export default PnmacRow;